import { IDynamicModel } from '../dynamic.interface';

export interface DrDisplayControlGroupDto {
  groupType: string;
  groupName: string;
  controls: IDynamicModel[];
}

export interface DrDisplayContainerDto {
  metadata; //DrContainerMetadataDto;
  controlGroups: DrDisplayControlGroupDto[];
}

/**
 * Which apps support the dynamic API
 */
export const dynamicSupportedAppTags: Array<{
  title: string;
  tag: string;
  default?: boolean;
}> = [
  {
    title: 'HSE Toolbox',
    tag: 'app:hse-toolbox',
    default: true,
  },
  {
    title: 'HSE Toolbox',
    tag: 'safety',
  },
  {
    title: 'My UPS',
    tag: 'app:my-ups',
  },
  {
    // WI 34928: Warehouse Mobile (nativescript-tool-tracker), e.g. the NIFTY NCR form
    title: 'Tool Tracker',
    tag: 'app:tool-tracker',
  },
];
